import { push } from 'connected-react-router';
import { paths } from '../../../routes/paths';
import CoreAPIService from '../../../utils/core-api';
import { fetchAction } from '../../actions';
import { PrebookGroupCreationPayload, PrebookById } from '../api-types';

export const name: string = 'prebook';

export const types = {
    GET_PREBOOKS: name + '/GET_PREBOOKS',
    GET_PREBOOK: name + '/GET_PREBOOK',
    CREATE_PREBOOK: name + '/CREATE_PREBOOK',
    UPDATE_PREBOOK: name + '/UPDATE_PREBOOK',
    DELETE_PREBOOK: name + '/DELETE_PREBOOK',
    ADD_DRIVER_PREBOOK: name + '/ADD_DRIVER_PREBOOK',
    DELETE_DRIVER_PREBOOK: name + '/DELETE_DRIVER_PREBOOK',
    // GET_PREBOOK_PERIODS: name + '/GET_PREBOOK_PERIODS',
    // CREATE_PREBOOK_PERIODS: name + '/CREATE_PREBOOK_PERIODS',
    // EXPORT_PREBOOKS: name + '/EXPORT_PREBOOKS',
    // IMPORT_PREBOOKS: name + '/IMPORT_PREBOOKS',
};

interface PrebookState {
    prebooks: PrebookById;
}

const initialState: PrebookState = {
    prebooks: {},
};

const reducer = (state = initialState, action): PrebookState => {
    const payload = action.payload;
    const parameters = action.parameters;
    const id = parameters ? parameters.id : 0;

    switch (action.type) {
        case types.GET_PREBOOKS:
            return {
                ...state,
                prebooks: payload.data ?? payload,
            };
        case types.GET_PREBOOK:
        case types.UPDATE_PREBOOK:
            return {
                ...state,
                prebooks: {
                    ...state.prebooks,
                    [id]: payload,
                },
            };
        case types.CREATE_PREBOOK:
            return {
                ...state,
                prebooks: {
                    ...state.prebooks,
                    [payload.id]: payload,
                },
            };
        case types.DELETE_PREBOOK:
            const next = { ...state };
            delete next.prebooks[id];
            return next;
        default:
            return state;
    }
};
export default reducer;

export const actions = {
    getPrebooks: () => fetchAction(CoreAPIService.get(`/core/prebook/groups`), types.GET_PREBOOKS, {}),
    getPrebook: (id: any) => fetchAction(CoreAPIService.get(`/core/prebook/groups/${id}`), types.GET_PREBOOK, { id }),
    createPrebook: (payload: PrebookGroupCreationPayload) =>
        fetchAction(
            CoreAPIService.post(`/core/prebook/groups`, payload),
            types.CREATE_PREBOOK,
            {},
            {
                success: (dispatch, response) => {
                    dispatch(push(response?.id ? `${paths.prebooks}/${response.id}` : `${paths.prebooks}/`));
                },
            },
        ),
    updatePrebook: (id: any, payload: PrebookGroupCreationPayload) =>
        fetchAction(
            CoreAPIService.put(`/core/prebook/groups/${id}`, payload),
            types.UPDATE_PREBOOK,
            { id },
            {
                success: (dispatch) => {
                    dispatch(push(`${paths.prebooks}/${id}`));
                },
            },
        ),
    deletePrebook: (id: any) =>
        fetchAction(
            CoreAPIService.delete(`/core/prebook/groups/${id}`),
            types.DELETE_PREBOOK,
            { id },
            {
                success: (dispatch) => {
                    dispatch(push(paths.prebooks));
                },
            },
        ),

    addDriverToPrebook: (idDriver: number, idPrebook: any, callback?) =>
        fetchAction(
            CoreAPIService.post(`/core/drivers/${idDriver}`, { details: { prebookGroup: { id: idPrebook } } }),
            types.ADD_DRIVER_PREBOOK,
            { idDriver, idPrebook },
            {
                success: callback,
            },
        ),
    deleteDriverFromPrebook: (idDriver: number, callback?) =>
        fetchAction(
            CoreAPIService.post(`/core/drivers/${idDriver}`, {
                details: { prebookGroup: { id: '37b286f6-3a21-4b5a-beb5-60563234acf2' } },
            }),
            types.DELETE_DRIVER_PREBOOK,
            { idDriver },
            {
                success: callback,
            },
        ),

    // exportPrebooks: () =>
    //    fetchAction(CoreAPIService.get(`/core/prebook/groups/export`), types.EXPORT_PREBOOKS, {}),
    // importPrebooks: (payload: { start: number; file: any }) =>
    //    fetchAction(
    //         CoreAPIService.post(`/core/prebook/coeffs/import`, payload),
    //         types.IMPORT_PREBOOKS,
    //         {},
    //     ),
    // getPrebookPeriods: () =>
    //    fetchAction(CoreAPIService.get(`/core/prebook/groups`), types.GET_PREBOOK_PERIODS, {}),
    // createPrebookPeriod: (payload: { start: number }) =>
    //    fetchAction(
    //         CoreAPIService.post(`/core/prebook/groups`, payload),
    //         types.CREATE_PREBOOK_PERIODS,
    //         {},
    //     ),
    // deletePrebookPeriods: () =>
    //    fetchAction(CoreAPIService.delete(`/core/prebook/groups`), types.DELETE_PREBOOK_PERIODS, {}),
};

const localState = (state: any): PrebookState => state[name] || initialState;
export const selectors = {
    prebooks: (state) => localState(state).prebooks,
};
